<template>
    <div>
        <!-- 決済前のサイドメニュー -->
        <sidebar-menu
            v-if="this.$store.getters['managerSession/managerInfo'].paid === false && this.$store.getters['managerSession/managerInfo'].profile != null"
            :menu="menuPrePay" :collapsed="!expanded">
            <div slot="header">
            </div>
        </sidebar-menu>
        <!-- 決済前&プロフィール登録前のサイドメニュー -->
        <sidebar-menu
            v-else-if="this.$store.getters['managerSession/managerInfo'].paid === false && this.$store.getters['managerSession/managerInfo'].profile == null"
            :menu="menuPrePayNoProfileMenu" :collapsed="!expanded">
            <div slot="header">
            </div>
        </sidebar-menu>
        <!-- 決済後のサイドメニュー -->
        <sidebar-menu v-else-if="this.$store.getters['managerSession/managerInfo'].paid === true" :menu="menuPaid"
            :collapsed="!expanded">
            <div slot="header">
            </div>
        </sidebar-menu>
        <div class="">
            <div class="header-right-layout-master">
                <div class="berger" @click="showMenuMobile">
                    <i class="icon-view_headline"></i>
                </div>
                <img :src="require('@/assets/img/logo.png')" alt />
            </div>
            <div class="pad-1rem">
                <router-view />
            </div>
            <div class="footer-right-layout-master">
                <div class="logo-login">
                    <img :src="require('@/assets/img/logo-footer.png')" alt />
                </div>
                <div class="info-footer">
                    <p>日本最大級のエンタメ特化のマッチングプラットフォーム</p>
                    <p>Copyright©Backstage All rights Reserved.</p>
                </div>
            </div>
        </div>
        <!-- モバイル時のフッターメニュー -->
        <div class="footer-navi">
            <div class="row">
                <div class="col p-0">
                    <a href="/company/dashboard">
                        <font-awesome-icon :icon="'home'"></font-awesome-icon>
                        <p>ホーム (案件管理)</p>
                    </a>
                </div>
                <div class="col p-0">
                    <a href="/company/register/project">
                        <font-awesome-icon :icon="'clipboard'"></font-awesome-icon>
                        <p>案件登録</p>
                    </a>
                </div>
                <div class="col p-0 sp-msg-navi">
                    <a href="/company/messager">
                        <font-awesome-icon :icon="'comments'"></font-awesome-icon>
                        <p>メッセージ</p>
                    </a>
                    <p class="unread-num-sp" v-if="notification.length > 0">{{ notification.length }}</p>
                </div>
                <div class="col p-0">
                    <a href="/company/favorite-artisan">
                        <font-awesome-icon :icon="'heart'"></font-awesome-icon>
                        <p>お気に入り</p>
                    </a>
                </div>
                <div class="col p-0">
                    <a href="/company/edit-profile">
                        <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                        <p>登録内容編集</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FooterLayout from './inc/footer-layout'
import AppNav from '../components/app-nav'
import AccountModel from "../../app/modules/company/c-user/models/AccountModel";
import SidebarMenu from "./inc/SidebarMenu";
import companyMenu from './company/company-menu'
import companyPrePayMenu from './company/company-prepay-menu'
import companyPrePayNoProfileMenu from './company/company-prepay-no-profile-menu'
import ViewProfile from '../../app/modules/company/c-auth/script/profile'
import { mapGetters } from "vuex";
import jquery from "jquery";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'company-layout',
    components: { SidebarMenu, AppNav, FooterLayout, FontAwesomeIcon },
    mixins: [ViewProfile],
    data: () => ({
        expanded: true,
        menuPrePay: companyPrePayMenu,
        menuPaid: companyMenu,
        menuPrePayNoProfileMenu: companyPrePayNoProfileMenu,
        isActive: false
    }),
    mounted() {
        this.oldHtmlClass = document.documentElement.className.split(" ");
        document.documentElement.setAttribute('class', 'manager-class has-aside-left has-aside-expanded')
    },
    computed: {
        isRoot() {
            return this.$store.getters['userSession/userInfo'].type === AccountModel.TYPE.root
        },
        isCustomer() {
            return this.$store.getters['userSession/userInfo'].type === AccountModel.TYPE.customer
        },
        isAdmin() {
            return true
            // return this.$store.getters['userSession/userInfo'].type === AccountModel.TYPE.admin
        },
        ...mapGetters({
            userInfo: 'managerSession/managerInfo'
        }),
        notification() {
            return this.$store.getters.notification
        }
    },
    methods: {
        showMenuMobile() {
            jquery('.v-sidebar-menu').addClass("show-menu-mobile");
            jquery('.v-sidebar-menu').removeClass("close-menu");
        },
        goDashboard() {
            this.$router.push('/company/c-user/manager', () => {
            })
        },
        logout() {
            this.userLogout()
        }
    }
}
</script>

<style lang="scss" scoped>
#master-left-menu {
    width: 200px;
    padding-right: 0;
    height: calc(100vh - 55px);
}

.master-content {
    padding-right: 0.75rem;
}

.menu {
    position: fixed;
    top: 60px;
    width: 188px;
    height: calc(100vh - 55px);
    /*overflow-y: scroll;*/
}

.home {
    min-height: calc(100vh - 55px);
}

.footer {
    margin-left: -10px;
}

img {
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
}
</style>
